import styled from 'styled-components';

export const Container = styled.div`
    bottom: 30px;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    z-index: 1;
`;
